import React, { Fragment, useState, useEffect } from "react";

import { useForm } from "react-hook-form";
import { useSelector, useDispatch } from "react-redux";
import {
  fetchUserBySin,
  userSelector,
  clearState,
} from "../features/User/UserSlice";
import toast from "react-hot-toast";
import { useHistory } from "react-router-dom";
import AuthNavBar from "./components/nav/AuthNav";
import { useTranslation } from "react-i18next";

const UpdatePage = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const { register, errors, handleSubmit } = useForm();
  const { isFetching, isSuccess, isError, errorMessage } =
    useSelector(userSelector);
  const onSubmit = (data) => {
    if (
      document.getElementById("modField").value == 0
    ) {
      alert("Select Modification type")
    }
    else{
      dispatch(fetchUserBySin(data));
    }
    
  };

  const [checkerStatus, setCheckerStatus] = useState(false);


  useEffect(() => {
    if (localStorage.getItem("sin") === "undefined") {
      setCheckerStatus(true);
    }
    return () => {
      dispatch(clearState());
    };
  }, []);

//   useEffect(() => {
//     if (isError) {
//       toast.error(errorMessage);
//       dispatch(clearState());
//     }

//     if (isSuccess) {
//       dispatch(clearState());
//       history.push("/");
//     }
//   }, [isError, isSuccess]);

  const required = (value) => {
    if (!value) {
      return (
        <div className="alert alert-danger" role="alert">{t("field_required")}</div>
      );
    }
  };

  

  const [modifyField, setModifyField] = useState("");
  const [showText, setShowText] = useState(false);

  function numberWithCommas(num) {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  let n = numberWithCommas(modifyField);
  console.log(n);

  const Alert = () => (
    <div style={{ color: "red" }}>{t("update_charge", { amount: n })}</div>
  );

  useEffect(() => {
    if (isError) {
      toast.error(errorMessage);
      dispatch(clearState());
      history.push("/update");
    }
    if (isSuccess) {
      dispatch(clearState());
      if (n === "700") {
        history.push("/otherfield");
      }
      else{
        history.push("/dobfield");
      }
      
    }
  }, [isError, isSuccess]);

  return (
    <div>
      <AuthNavBar />
      <div className="container-xxl m-lg-5">
        <div className="row">
          <div className="col">
            <div className="card shadow-sm p-3 mb-4 bg-white rounded">
              <div className="card-body">
                <h5 className="card-title">{t("information_update")}</h5>
                <small className="card-text">{t("declaration_text")}</small>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-4"></div>

          <div className="col-md-4">
            <center className="mt-3">
              <div className="card shadow-sm p-3 mb-4 bg-white rounded">
                <div className="card-body">
                  <h6 className="card-title">{t("retrieve_record")}</h6>
                  {
                      checkerStatus ? 
                      <span className="text-danger">{t("not_enrolled")}</span> :
                  <form onSubmit={handleSubmit(onSubmit)} method="POST">
                    <div class="mb-3">
                      <label for="exampleInputNumber" class="form-label" style={{ color: "grey" }}>{t("sin_label")}<span style={{color:"red"}}>*</span>
                      </label>
                      <input
                        name="sin"
                        type="text"
                        ref={register({ required: true })}
                        required
                        class="form-control"
                        aria-describedby="numberHelp"
                        value={localStorage.getItem('sin')}
                        disabled
                      />
                    </div>
                    <div class="mb-3">
                      <label for="exampleInputPassword1" class="form-label" style={{ color: "grey" }}>{t("first_name")}<span style={{color:"red"}}>*</span>
                      </label>
                      <input
                        name="firstname"
                        type="text"
                        autoComplete="current-password"
                        required
                        class="form-control"
                        id="exampleInputPassword1"
                      />
                    </div>
                    <div class="mb-3">
                      <label for="exampleInputPassword1" class="form-label" style={{ color: "grey" }}>{t("last_name")}<span style={{color:"red"}}>*</span>
                      </label>
                      <input
                        name="lastname"
                        type="text"
                        autoComplete="current-password"
                        required
                        class="form-control"
                        id="exampleInputPassword1"
                      />
                    </div>
                    <div className="mt-3">
                    <label for="exampleInputPassword1" class="form-label" style={{ color: "grey" }}>{t("select_update_type")}<span style={{color:"red"}}>*</span>
                      </label>
                    </div>
                    <div class="form-group">
                      <select
                        class="form-control"
                        id="modField"
                        onChange={(event) => {
                            setModifyField(event.target.value);
                            setShowText(true);
                          }}
                          required
                      >
                        <option value="0">{t("select_option")}</option>
                        <option value="15200">{t("correct_dob_option")}</option>
                        <option value="700">
                          {t("modify_other_fields_option")}
                        </option>
                        
                      </select>
                      <small>{showText && modifyField > 0 ? <Alert /> : null}</small>
                    </div>
                    
                      <button type="submit" class="btn btn-info mt-3">
                      {isFetching ? (
                        <svg
                          class="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                        >
                          <circle
                            class="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            stroke-width="4"
                          ></circle>
                          <path
                            class="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                          ></path>
                        </svg>
                      ) : null}
                      {t("search")}
                    </button>
                    
                    
                    {/* <Link type="submit" class="btn btn-info" to="/dashboard">{t("submit")}</Link> */}
                  </form>
                }
                  <div className="col-md-4"></div>
                </div>
              </div>
            </center>
          </div>
        </div>
      </div>
    </div>
  );
};
export default UpdatePage;
